import React, { useState } from "react";
import Popup from "reactjs-popup";
import DemoContact from "../DemoContact";
import ContactUs from "../../pages/ContactUs";

const ContactFooter = () => {
  const [popupOpen, setPopup] = useState(false);
  const [contact, setContact] = useState(false);

  const closeModal = () => {
    setPopup(false);
  };

  const closeContact = () => {
    setContact(false);
  };

  return (
    <section className="flex px-10 py-20 items-center flex-col gap-10" style={{ backgroundColor: '#0f172a' }}>
      <Popup
        onClose={closeModal}
        modal
        open={popupOpen}
        className="rounded-xl"
        position="center center"
      >
        <DemoContact handleClose={closeModal} />
      </Popup>
      <Popup
        onClose={closeContact}
        modal
        open={contact}
        className="rounded-xl"
        position="center center"
      >
        <ContactUs closeContact={closeContact} />
      </Popup>
      <div className="flex flex-col gap-10 font-[500] items-center">
        <h2 className="md:text-5xl text-3xl" style={{ color: '#ffffff' }}>Contact Us</h2>
        <p className="md:text-3xl text-xl text-center" style={{ color: '#e2e8f0' }}>
          Learn how we can empower your R&D and Medical Affairs teams
        </p>
      </div>
      <div className="flex items-center gap-4">
        <button
          onClick={() => setPopup(true)}
          className="md:px-10 h-full px-5 py-3 rounded-lg hover:scale-105 transition-all md:w-auto ease-in-out duration-200 md:text-2xl text-md font-medium"
          style={{ backgroundColor: '#ffffff', color: '#0f172a' }}
        >
          Request a Demo
        </button>
        <button
          onClick={() => setContact(true)}
          className="md:px-10 h-full px-5 py-3 rounded-lg hover:scale-105 transition-all md:w-auto ease-in-out duration-200 md:text-2xl text-md font-medium border"
          style={{ backgroundColor: 'transparent', color: '#ffffff', borderColor: '#ffffff' }}
        >
          Talk to an Expert
        </button>
      </div>
    </section>
  );
};

export default ContactFooter;
